import { MaskedInputProps } from '../../types';
import { MaskedInput } from './Input';

export function InputCEP(props: MaskedInputProps) {
  return <MaskedInput {...props} mask="00000-000" />;
}
